import { css, useTheme } from "@emotion/react";
import { forwardRef } from "react";

import useThemeProps from "./useThemeProps.jsx";

export default forwardRef(function Grid(props, ref) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "Grid",
  });
  let {
    children,
    spacing = 2,
    rowGap = spacing,
    columnGap = spacing,
    size = 40,
    columnCount = "auto-fit",
    ...restProps
  } = props;

  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: repeat(
          ${isNaN(columnCount)
            ? columnCount
            : `repeat(${parseInt(columnCount)})`},
          minmax(min(100%, ${theme.getLength(size)}), 1fr)
        );
        row-gap: ${theme.getLength(rowGap)};
        column-gap: ${theme.getLength(columnGap)};
      `}
      ref={ref}
      {...restProps}
    >
      {children}
    </div>
  );
});
